import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css"
import Loaderdots from "../../components/LoaderDots/Loaderdots";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false); // Loader state
  
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`https://riymay.com/api/v1/user/forgot/password/?email=${email}`)

      if (!response.ok) {
        toast.error("❌ Failed to send OTP. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastId:"FailedSend"
        });
      } else {
        toast.success("✅ OTP sent successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastId:"successSend"

        });
        navigate("/password-reset", { state: { email: email } })
      }
      

    } catch (error) {
      console.error(error)
    }
  };
  if (loading) return <div><Loaderdots /></div>

  return ( 
    <div className="login-container">

    <div className="login-box">
    
      <h2 className="login-heading">Forgot Password</h2>
      <form onSubmit={handleSubmit} className="login-form-container">
        <div className="form-group">
          {/* <label htmlFor="email" className="form-label">
            Email Address
          </label> */}
          <input
            type="email"
            id="email"
            name="email"
            className="login-input"
            placeholder="Enter your email"
            value={email}
            onChange={handleInputChange}
            required
          />
        </div>
        <button type="submit" className="login-button" >send
        </button>
      </form>
    </div>
    </div>

  );
};

export default ForgotPassword;
